import * as React from 'react'
import { Typography, Icons } from '@lacedltd/laced-components'
import { useTranslation } from 'hooks'
import { iconEmpty } from 'images'
import * as S from './NoResults.styles'

const NoResults: React.FC<NoResultsProps> = ({
  heading,
  subHeading,
  loading,
  action
}) => {
  const { t } = useTranslation()

  React.useEffect(() => {
    const img = new Image()

    img.src = iconEmpty
  }, [])

  return (
    <S.NoResultsCard>
      {loading ? (
        <Icons.LoadingCircle />
      ) : (
        <>
          <img src={iconEmpty} alt={t('shared.empty')} />
          <Typography.Heading as="h4">{heading}</Typography.Heading>
          {subHeading && (
            <Typography.Text as="p" variant="body">
              {subHeading}
            </Typography.Text>
          )}
          {action && (
            <a
              href={action.href}
              title={action.label}
              className="btn btn--tertiary"
            >
              {action.label}
            </a>
          )}
        </>
      )}
    </S.NoResultsCard>
  )
}

export default NoResults

interface NoResultsProps {
  heading: string
  subHeading?: string
  loading?: boolean
  action?: {
    href: string
    label: string
  }
}
